import React from 'react';
import Icon from '../common/Icon';

export default function NavigationBar({ open, isLoggedIn, name, sessionExpires, ...props }) {
  const logoutPage = window.kvs.logoutPage;

  return (
    <header {...props} className="nav__bar">
      {
        isLoggedIn === true
          ? <div className="nav__logout nav__logout--mobile">
            <div className="nav__user">
              <div className="nav__user__icon">
                <Icon name="user" />
              </div>
              <div className="nav__user__id">
                <p className="lead">
                  {name}
                </p>
              </div>
            </div>
            <a href={logoutPage} className="nav__user__logout">
              <Icon name="sign-out-alt-regular" />
              <p className="lead">Logga ut</p>
              <div className="nav__user__time">
                <p className="lead"></p>
              </div>
            </a>
          </div>
          : <div className="nav__login nav__login--mobile">
            <div className="nav__user">
              <Icon name="user" />
            </div>
            <label className="nav__item__link" htmlFor="mega-nav-5">
              Logga in
            </label>
          </div>
      }
    </header>
  )
};


